import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=3626b03b&scoped=true&"
import script from "./QuestionPreview.vue?vue&type=script&lang=js&"
export * from "./QuestionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626b03b",
  null
  
)

export default component.exports